export const getBreadcrumbItems = (
    pathname: string | null,
    searchParams: any,
    navData: any[],
) => {
    const items = [
        {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.tooffi.com",
        },
    ];

    if (
        !pathname ||
        !pathname.startsWith("/listing/") ||
        !navData ||
        navData.length === 0
    ) {
        return items;
    }

    // Get query parameters
    const getParam = (key: string) => {
        if (searchParams && typeof searchParams.get === "function") {
            return searchParams.get(key);
        }
        return searchParams?.[key];
    };

    const productSubtypeId = getParam("product_subtype_id");
    const flavourIds = getParam("flavour_ids");
    const collectionId = getParam("collection_id");

    // Find the main category that matches the pathname
    // pathname doesn't include query params, so we need to extract base path from item.url
    const mainCategory = navData.find((item: any) => {
        if (!item.url) return false;
        // Extract the base path from the URL (remove query params)
        const itemBasePath = item.url.split("?")[0];
        return pathname === itemBasePath;
    });

    if (!mainCategory) {
        return items;
    }

    // Add main category to breadcrumb
    items.push({
        "@type": "ListItem",
        position: items.length + 1,
        name: mainCategory.title,
        item: `https://www.tooffi.com${mainCategory.url}`,
    });

    // Check for collection
    if (collectionId && mainCategory.items) {
        const collectionItem = mainCategory.items.find(
            (item: any) => item.id?.toString() === collectionId,
        );
        if (collectionItem) {
            items.push({
                "@type": "ListItem",
                position: items.length + 1,
                name: collectionItem.heading,
                item: `https://www.tooffi.com${collectionItem.url}`,
            });
        }
    }
    // Check for subtype
    else if (productSubtypeId && mainCategory.subTypes) {
        const subtypeItem = mainCategory.subTypes.find(
            (item: any) => item.id?.toString() === productSubtypeId,
        );
        if (subtypeItem) {
            items.push({
                "@type": "ListItem",
                position: items.length + 1,
                name: subtypeItem.heading,
                item: `https://www.tooffi.com${subtypeItem.url}`,
            });
        }
    }
    // Check for flavor
    else if (flavourIds && mainCategory.flavors?.items) {
        const flavorId = flavourIds === "all" ? null : flavourIds;
        if (flavorId) {
            const flavorItem = mainCategory.flavors.items.find(
                (item: any) => item.id?.toString() === flavorId,
            );
            if (flavorItem) {
                items.push({
                    "@type": "ListItem",
                    position: items.length + 1,
                    name: flavorItem.heading,
                    item: `https://www.tooffi.com${flavorItem.url}`,
                });
            }
        }
    }

    return items;
};
